import { ADD_SERIES } from "../constants/seriesConstants";

export const addSeries = series => ({
  type: ADD_SERIES,
  payload: series
});
